export const TOKEN = 'access_token'
export const REFRESH_TOKEN = 'refresh_token'